module.exports = __webpack_public_path__ + "img/DE01564.fc0ada67.png";